import { apiClient as api } from "./httpClient";

/**
 * Pacotes agendados (RN-224, item 193): sessões dos serviços com mais de 1 sessão configurada, linha a linha,
 * com o agendamento pai reconstruído (série → recibo → "Agendado Em" → sequência de datas). Só consulta.
 */
export interface PackageSessionRow {
  scheduleId: string;
  parentId: string;
  /** "3 de 4", ou "excluída". */
  session: string;
  active: boolean;
  origin: string;
  packageSituation: string;
  patientId: string;
  patientName: string;
  serviceName: string;
  planName: string;
  professionalName: string;
  createdAt: string;
  start: string;
  end: string;
  confirmation: string;
  presence: string;
  expected: number;
  paid: boolean;
  realized: number | null;
  paymentDate: string | null;
  paymentId: string | null;
  beforePeriod: boolean;
}

export interface PackageSessionsGroup {
  name: string;
  packages: number;
  sessions: number;
}

export interface PackageSessionsOption {
  id: string;
  name: string;
}

export interface PackageSessionsReport {
  from: string;
  to: string | null;
  packages: number;
  patients: number;
  activeSessions: number;
  excludedSessions: number;
  expected: number;
  realized: number;
  paidSessions: number;
  byOrigin: PackageSessionsGroup[];
  bySituation: PackageSessionsGroup[];
  items: PackageSessionRow[];
  services: PackageSessionsOption[];
  plans: PackageSessionsOption[];
  professionals: PackageSessionsOption[];
}

export interface PackageSessionsFilters {
  from: string;
  to: string;
  patient: string;
  professionalId: string;
  serviceTypeId: string;
  planKey: string;
  origin: string;
  packageSituation: string;
  paymentSituation: string;
  includeExcluded: boolean;
}

const query = (f: PackageSessionsFilters): string => {
  const params = new URLSearchParams();
  Object.entries(f).forEach(([chave, valor]) => {
    if (typeof valor === "boolean") params.append(chave, String(valor));
    else if (valor) params.append(chave, valor);
  });
  return `?${params.toString()}`;
};

export const packageSessionsService = {
  get: async (filters: PackageSessionsFilters): Promise<PackageSessionsReport> => {
    const response = await api.get(`/reports/package-sessions${query(filters)}`, { timeout: 90000 });
    return response.data;
  },

  exportXlsx: async (filters: PackageSessionsFilters): Promise<Blob> => {
    const response = await api.get(`/reports/package-sessions/export${query(filters)}`, {
      responseType: "blob",
      timeout: 90000,
    });
    return response.data;
  },
};
